export const colorSet = [
  "#0569A2",
  "#E9D8A6",
  "#F54C87",
  "#BC94AC",
  "#70CA63",
  "#E9573F",
  "#36BC9B",
  "#926DDE",
  "#BC94AC",
  "#184E74",
];
